import createImmutableSelector from 'lib/immutable/selector'
import { ICountries } from './../models'

// TODO: import Store type and add reducer type in Store interface
const getCountries = (state: any): ICountries => state.get('countriesReducer')

export const countriesSelector = createImmutableSelector(getCountries, (countries) => countries)
